// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DataCenterFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DataCenterFilledIcon" ref={forwardedRef} {...props}>
      <path d="M5.75 3.75a1 1 0 0 1 1-1h6.5a1 1 0 0 1 1 1v12.5a1 1 0 0 1-1 1h-6.5a1 1 0 0 1-1-1zm3.375 1V6.5h1.75V4.75zm2.872 3.75h-4v1.25h4zm-4 2.5v1.25h4V11zM12 13.5H8v1.25h4z" />
      <path d="M1.75 4.75h3v10.5h-3z" />
      <path d="M18.25 4.75h-3v10.5h3z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const DataCenterFilledIcon = /* @__PURE__ */ Object.assign(
  DataCenterFilledIconComponent,
  { displayName: 'DataCenterFilledIcon' },
);
